import React, {Component} from 'react';
import cookie from 'react-cookies'
import fire from '../Config-Files/firebaseconfig.js';
import TextInput from '../Material-UI-Components/TextInput.js';
import Grid from '@material-ui/core/Grid';
import Password from '../Material-UI-Components/TextPassword';
import Button from '@material-ui/core/Button';
import Loader from 'react-loader-spinner';


const registerModule=[
    { "id":"1", "columnName":"First Name", "fieldName":"firstName", "isReadOnly":false,  "autocomplete":"off", "fieldType":"text", "required": true},
    { "id":"2", "columnName":"Last Name", "fieldName":"lastName", "isReadOnly":false,  "autocomplete":"off", "fieldType":"text", "required": true},
    { "id":"3", "columnName":"Email Address", "fieldName":"emailAddress", "isReadOnly":false, "autocomplete":"off", "fieldType":"text", "required": true},
    { "id":"4", "columnName":"Password", "fieldName":"password", "isReadOnly":false,  "autocomplete":"off", "fieldType":"password", "required": true}
];

export default class RegisterModule extends Component{

    constructor(props)
    {
        super(props);
        this.state={
            user:{},
            loader: false,
            errorMessage:'',
            uid:''
        }
        this.register = this.register.bind(this);
        this.addUser = this.addUser.bind(this);
    }

    checkError = ()=>{
        if(this.state["firstName"]===null || this.state["firstName"].trim().length===0){
            this.setState({errorMessage:"First Name cannot be empty"});
            return false;
        }
        if(this.validateEmail(this.state["emailAddress"]) === false){
            this.setState({errorMessage:"Email address is not valid"});
            return false;
        }
        if(this.state["password"]!==null && this.state["password"].trim().length<8){
            this.setState({errorMessage:"Password must be atleast 8 character long"});
            return false;
        }
            this.setState({errorMessage:''});
            return true;
      };
    
    validateEmail = (text) => {
      let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/ ;
        return reg.test(text);
    }; 

    componentWillMount()
    {
        registerModule.map((index)=>{
            this.setState({[index.fieldName]:index.default ? index.default :''});
        });
    }
  
    setStateValueOnClick = (key, value) => {
        this.setState({[key]:value});
    };

    addUser()
    {
        fetch("https://www.api.pratiiti.in/register",{
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': 'Bearer '+cookie.load('token')
            },
            method: "POST",
            body: JSON.stringify({"uid":cookie.load('uid'), "firstName":this.state["firstName"], 
            "lastName": this.state["lastName"] })
          })
            .then(res => res.json())
            .then(
              (result) => {
                if(result.status === "Success")
                {
                    this.setState({errorMessage:'Register successfully'});
                    this.props.onClickFunction('register', 'success');
                }
                else if(result.status === "Fail")
                {
                    this.setState({errorMessage:'Failed to register'});
                }
                this.setState({loader:false});
              }
            )
            .catch(
                (error)=>
                {
                this.setState({errorMessage:error, loader:false});
                }
            )
    }

register()
{
    this.setState({loader:true});
    var com = this;
    if(this.checkError())
    {
        fire.auth().createUserWithEmailAndPassword(this.state.emailAddress,this.state.password)
        .then((user)=>{
            fire.auth().currentUser.updateProfile({
                displayName: com.state.firstName + " " + com.state.lastName
            }).then(function() {
                cookie.save('token', user["user"]["xa"], { path: '/' });
                com.addUser();
            }).catch(function(error) {
                com.setState({loader:false, errorMessage:'Something went wrong'});
            });
        }).catch((err)=>{
            com.setState({loader:false, errorMessage:'Something went wrong'});
            console.log(err);
        })
    }
    else
    {
        com.setState({loader:false});
    }
}

    getTableContent = () => {
  
        const getFieldType = (nextItem) => {
          switch (nextItem.fieldType) {
            case "text":
                return (<TextInput value={this.state[nextItem.fieldName]} fieldConfiguration={nextItem} disableReadonly = {this.props.disableReadonly} onClickFunction = {this.setStateValueOnClick}/>);
            case "password":
                return (<Password value={this.state[nextItem.fieldName]} fieldConfiguration={nextItem} disableReadonly = {this.props.disableReadonly} onClickFunction = {this.setStateValueOnClick}/>)
            default:
              return null;
          }
        };
      
        const iterateItem = (item) => {
           return item.map(function (nextItem, j) {
            return (
              <Grid xs={12} sm={6} md={8}>
                {getFieldType(nextItem)}
              </Grid>
           );
           })
        }
            return (
                <div>
                  {iterateItem(registerModule)}
                </div>
            );
      };

    render(){
        const elements = this.getTableContent();
        return(
            <div>
                {elements}
                <div style={{marginTop:10, marginLeft:10}}>
                {this.state.loader? 
                <Loader type="Circles" color="#f7941e" height={40} width={40}/>
                :
                <div>
                <div style={{color:'#FF0000'}}>{this.state.errorMessage}</div>
                <Button 
                    onClick={() => this.register()} 
                    style={{marginTop:20, 
                    color: '#ffffff', 
                    backgroundColor: '#f7941e', 
                    fontSize: 13}}
                >
                {"Sign up"}
                </Button>
                </div>
                }
                </div>
            </div>
        )
    }
}